<template>
  <div>
    <textarea v-model='content'>
    </textarea>
    <br/>
    <input type='button' @click='submit' value='留言'/>
  </div>
</template>
<script>
const axios = require('axios');

export default {
  data () {
    return {
      content: ''
    }
  },
  methods: {
    submit: function(){
      axios.post('/api/interface/blogs/add_comment',
        {
          content: this.content
        }
      )
      .then((response) => {
          alert("提交成功!, 刚才提交的内容是：" + response.data.content)
        },
        (response) => {
          alert("出错了")
        }
      )
    }
  }
}
</script>
